import { SvgIcon, SxProps } from "@mui/material";
import SvgUsersIcon from "jsx:../../../Images/Icons/FontAwesome/solid/users.svg";

export function UsersSolidIcon(props: SxProps) {
    return <SvgIcon component={SvgUsersIcon} inheritViewBox sx={props} />;
}
